import { useNavigate } from 'react-router-dom'
import { Table } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'

export default function DamagesSoughtForm({ location }) {
  console.log('DamagesSoughtForm rendered: ', location)

  let init = {
    plaintiffStatus: [],
    plaintiffCounsel: '',
    dateAssignedFrom: '',
    dateAssignedTo: '',
  }

  const navigate = useNavigate()
  init = initialFormValues('DamagesSoughtForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    console.log('DamagesSoughtForm.submitSearch', inputs)
    for (let i = 0; i < inputs.plaintiffStatus.length; i++) {
      if (inputs.plaintiffStatus[i] === 'All') {
        inputs.plaintiffStatus.splice(i, 1)
      }
    }
    inputs.plaintiffCounsel = inputs.plaintiffCounsel === 'All' ? inputs.plaintiffCounsel = '' : inputs.plaintiffCounsel

    submitFormValues('DamagesSoughtForm', navigate, inputs, 'damages_sought.damages_sought_report')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText='Damages Sought Report' />
            <tbody>
              <CustomSelectListInput label="Plaintiff Status" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="plaintiff_status" name='plaintiffStatus' multiple={true} allOption={true} defaultValue={inputs.plaintiffStatus} />              
              <DateRangeInput label='Date Assigned' name='dateAssigned' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateAssignedFrom} defaultValueTo={inputs.dateAssignedTo} />
              <CustomSelectListInput label="Plaintiff Counsel" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="opposing_firm" name='plaintiffCounsel' defaultValue={inputs.plaintiffCounsel} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}
